export const manajemen_resiko = {
  router: [
    {
      name: "MANAJEMEN RESIKO",
      key: "manajemen_resiko",
      path: "/admin/master/manajemen-resiko",
      apiUrl: {
        data: "master/api/manajemen/resiko/",
        preview: "master/api/manajemen/resiko/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "MANAJEMEN RESIKO",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
